import { GiftsGaloreSlice } from "./types";

export const initialState: GiftsGaloreSlice = {
	data: undefined,
	tracker: undefined,
	seenRewardedPopUp: false,
	trackerLoading: false
};
